import React, { useState, useEffect } from 'react'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  ButtonGroup,
  Row,
  Col,
  Dropdown,
  ControlLabel,
  Input,
  SelectPicker,
  Uploader,
} from 'rsuite'
import pathname from '../../constants/pathname'
import { useHistory } from 'react-router-dom'
import { budgetFormat } from '../../utils/formatterUtil'
import EditButton from '../../components/buttons/editButton/EditButton'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import {
  isImageOrPdf,
  isRequired,
  isValidators,
  requiredFiled,
  getMaxLengthData,
} from '../../utils/ValidatorUtils'
import { useForm, Controller } from 'react-hook-form'
import classNames from 'classnames'
import InputForm from '../../components/forms/input/InputForm'
import AppContext from '../../context/AppContext'
import { sessionGetItemStr } from '../../utils/sessionHelpers'
import moment from 'moment'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'

export default function ProjectMonitorRecordForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  rowData,
  isAddBankAccount,
  projectStartDate,
  projectEndDate,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const history = useHistory()
  const [tableData, setTableData] = useState([])
  const [formSchema, setFormSchema] = useState(schema)
  const { theme } = React.useContext(AppContext)
  console.log('formSchema==>', formSchema)

  // useEffect(() => {
  //   if (rowData && !isAddBankAccount) {
  //     // console.log('rowData', rowData.accountNo)

  //     setValue(formSchema.bankName.name, rowData.bankCode)
  //     setValue(formSchema.accountName.name, rowData.accountName)
  //     setValue(formSchema.bankBranch.name, rowData.bankBranch)
  //     setValue(formSchema.accountNo.name, rowData.accountNo)
  //     setValue(formSchema.accountType.name, rowData.accountTypeCode)
  //     clearErrors()
  //   } else {
  //     setValue(formSchema.bankName.name, '')
  //     setValue(formSchema.accountName.name, '')
  //     setValue(formSchema.bankBranch.name, '')
  //     setValue(formSchema.accountNo.name, '')
  //     setValue(formSchema.accountType.name, '')
  //   }
  // }, [rowData])

  return (
    <>
      <Row>
        <Row>
          <Col lg={4} md={4} sm={4} xs={4}>
            <div style={{ marginTop: 12 }}>
              <ControlLabel
                className={classNames(isRequired(formSchema.dateFollow.validators) && 'required')}
              >
                {formSchema.dateFollow.label}
              </ControlLabel>
            </div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <Controller
              key={formSchema.dateFollow.name}
              name={formSchema.dateFollow.name}
              control={control}
              defaultValue={
                formSchema.dateFollow.value
                  ? moment(formSchema.dateFollow.value, DATE_PICKER_FORMAT).toDate()
                  : moment().startOf('day').toDate()
              }
              rules={isValidators(formSchema.dateFollow.validators)}
              render={(props) => {
                return (
                  <DatePickerCustom
                    {...props}
                    startDate={sessionGetItemStr('projectStartDate')}
                    endDate={sessionGetItemStr('projectEndDate')}
                  />
                )
              }}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
        <Row>
          <Col lg={4} md={4} sm={4} xs={4}>
            <div style={{ marginTop: 12 }}>
              <ControlLabel
                className={classNames(isRequired(formSchema.followTimes.validators) && 'required')}
              >
                {formSchema.followTimes.label}
              </ControlLabel>
            </div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <InputForm
              schema={formSchema.followTimes}
              // value={item.link}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              hideLabel={true}
              isInputNumber={true}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
        <Row>
          <Col lg={4} md={4} sm={4} xs={4}>
            <div style={{ marginTop: 12 }}>
              <ControlLabel
                className={classNames(
                  isRequired(formSchema.projectSuccessInput.validators) && 'required'
                )}
              >
                {formSchema.projectSuccessInput.label}
              </ControlLabel>
            </div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <InputForm
              schema={formSchema.projectSuccessInput}
              // value={item.link}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              hideLabel={true}
              isInputNumber={true}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={{ marginTop: 20 }}>
          {/* <Col lg={2} md={2} sm={2} xs={2}></Col> */}
          <Col lg={22} md={22} sm={22} xs={22}>
            <ControlLabel
              className={classNames(isRequired(formSchema.summarizeInput.validators) && 'required')}
            >
              {formSchema.summarizeInput.label}
            </ControlLabel>
            <InputForm
              schema={formSchema.summarizeInput}
              // value={item.link}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              hideLabel={true}
              componentClass="textarea"
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          {/* <Col lg={2} md={2} sm={2} xs={2}></Col> */}
          <Col lg={22} md={22} sm={22} xs={22}>
            <ControlLabel
              className={classNames(isRequired(formSchema.notesInput.validators) && 'required')}
            >
              {formSchema.notesInput.label}
            </ControlLabel>
            <InputForm
              schema={formSchema.notesInput}
              // value={item.link}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              hideLabel={true}
              componentClass="textarea"
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          {/* <Col lg={2} md={2} sm={2} xs={2}></Col> */}
          <Col lg={22} md={22} sm={22} xs={22}>
            <ErrorMessage error={errors[formSchema.filesInput.name]} />
            <ControlLabel
            // className={classNames(isRequired(formSchema.notesInput.validators) && 'required')}
            >
              {formSchema.filesInput.header}
            </ControlLabel>
            <Controller
              // key={activitiesImageSchema.attachFiles.name}
              name={formSchema.filesInput.name}
              control={control}
              rules={isValidators(formSchema.filesInput.validators)}
              defaultValue={''}
              render={(props) => {
                return (
                  <Uploader
                    accept={formSchema.filesInput.fileType || '.jpg, .jpeg, .png, .pdf'}
                    autoUpload={false}
                    disabled={formSchema.filesInput.disabled}
                    fileListVisible={true}
                    listType="picture-text"
                    fileList={props.value || []}
                    // onChange={(fileList) => {
                    //   if (isEmpty(fileList)) {
                    //     props.onChange(undefined)
                    //   } else {
                    //     let file = fileList[fileList.length - 1]

                    //     if(file.blobFile.size > (formSchema?.attachFiles?.fileSize || defaultMaxFileSize) * 1024 * 1024){
                    //       notification.open('error', {
                    //         title:
                    //           `ขนาดไฟล์เกิน ${formSchema.attachFiles.fileSize || defaultMaxFileSize} MB`,
                    //         duration: 5000,
                    //       })
                    //       return
                    //     }

                    //     if (isImageOrPdf(file.blobFile.type)) {
                    //       props.onChange(fileList)
                    //       setFileTypeError(false)
                    //     } else {
                    //       setFileTypeError(true)
                    //       notification.open('error', {
                    //         title:
                    //           'ชนิดที่รองรับ ' + formSchema.attachFiles.fileType ||
                    //           '.jpg, .jpeg, .png, .pdf',
                    //         duration: 5000,
                    //       })
                    //     }
                    //   }
                    // }}
                    draggable
                  >
                    <div>
                      <div
                        style={{ lineHeight: '50px' }}
                        className={classNames('uploader', `${theme[0]}-background`)}
                      >
                        <Icon size="4x" icon="upload2" />
                        <small className="uploder__text">
                          <p style={{ wordBreak: 'break-word' }}>
                            {`คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด ชนิดที่รองรับ : .jpg, .jpeg, .png, .pdf`}
                          </p>
                        </small>
                      </div>
                    </div>
                  </Uploader>
                )
              }}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
      </Row>
    </>
  )
}
